<div class="page-actions">
  <dv-button
    color="primary"
    icon="add"
    (click)="onCreateClick()"
    routerLink="new/information"
    [disabled]="(canAddReport$ | async) === false">
    {{ 'Report.New' | translate | uppercase }}
  </dv-button>
</div>
<div class="page-actions"></div>
<dv-vertical-splitter
  [resizableSide]="resizableSide.Right"
  id="reports-vertical-splitter">
  <div left-side>
    <app-reports-grid></app-reports-grid>
  </div>
  <div right-side>
    <router-outlet />
  </div>
</dv-vertical-splitter>
